import React from 'react';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT, SELECTION_TYPE } from '../../../../../framework/grid/GridFw';
import { BasePage } from '../../../../../framework/pages/BasePage';
 

export class ParametrosModal extends BasePage {
    
    
    createPageProperties = (pageApi) => {
        return {
            title: 'Visualización de Parámetros',
        }; 
    }
    
    renderPage(pageApi) {
        const getGridParametros = () => pageApi.getComponent('parametrosGrid');

        const fnDelete = (value, row, index) => {
            getGridParametros().deleteItem(row.key);      
        }

        const barHeaderConfig = {
            fields:[
                {...BUTTON_DEFAULT.SAVE, label:'Guardar', 
                    onClick: () => {  
                        getGridParametros().save();
                        pageApi.hideThisModal();
                    }
                },
                // {...BUTTON_DEFAULT.DELETE, label:'Eliminar Seleccionados', 
                //     onClick: () => {  
                //         console.log(getGridParametros().selectedItem)
                //     }
                // },
                {...BUTTON_DEFAULT.RETURN, onClick: () => pageApi.hideThisModal()}
            ]
        }

        const gridConfig = {
                rowId: 'id_rel_ss_muestras_cotizacion',
                showIndex: false,
                autoLoad: true,
                pagination: {
                    server: false,
                    size: 50,
                },
                // selection: SELECTION_TYPE.MULTIPLE,
                load: {
                    queryId: 311,
                    params: ()  =>{ 
                        return  {  
                            id_rel_ss_estacion: pageApi?.name?.data.id_rel_ss_estacion  || 0, 
                            id: pageApi?.name?.data.id, 
                            grupo: pageApi?.name?.data.descripcion_grupo, 
                            id_doc_cotizacion : pageApi?.name?.id_doc_cotizacion,
                            id_matriz: pageApi?.name?.data.id_matriz,
                            id_rel_cot_ana: pageApi?.name?.data.id_rel_cot_ana,
                            list_id_rel_cot_ana: pageApi?.name?.data.list_id_rel_cot_ana ,
                            ID_FILA: pageApi?.name?.data.key ,
                        }
                    }
                },
                save: {
                    queryId: 312,
                    params: {
                        id_rel_ss_estacion: pageApi?.name?.data.id_rel_ss_estacion  || 0, 
                        id: pageApi?.name?.data.id, 
                        grupo: pageApi?.name?.data.descripcion_grupo, 
                        id_doc_cotizacion : pageApi?.name?.id_doc_cotizacion,
                        id_matriz: pageApi?.name?.data.id_matriz
                    }
                },
                fields:[
                    {name: 'analisis', label:'Parámetro'},
                    {type:'select', name:'parametros', maxVisible: 2, label:'Sub Parámetros', labelName: 'parametrosDes', search: true, multiple:true, multipleInString: true, editable: true,
                        load: {
                            queryId: 305,
                            params : () => {
                                return {id_rel_metodo_matriz: getGridParametros()?.itemEditing?.id_rel_metodo_matriz}
                            }
                        }, 
                    },
                    {...COLUMN_DEFAULT.DELETE, title: 'Eliminar', color: 'red', onClick: fnDelete}
                ]
        };  
    
        return (
            <>
                <GridFw 
                    name="parametrosGrid" 
                    getParentApi={pageApi.getApi}
                    config={gridConfig}
                />
                <BarButtonFw 
                    name="agregarButton" 
                    getParentApi={pageApi.getApi}
                    config={barHeaderConfig}
                />
            </>
        )

    }
    
}